import { PlanktonProductConfig } from './PlanktonProductConfig';

const intCalkinsProductConfig: PlanktonProductConfig = {
  planktonVersionPrefix: 'hnm-lc',
  edsLtiRceToolId: '2ad55c2f-39e7-46fa-8c1f-f5035e473f73',
  edsLtiVideoToolId: '0b07ca1b-00ec-4763-9c63-7e4eb3cab483',
};

export default intCalkinsProductConfig;
